import { mergeDeepRight } from 'ramda'
import { useMemo } from 'react'
import { ThemeProvider } from 'styled-components'

import type { ReactNode } from 'react'
import type { SpacingKey, SpacingPx, SpacingValue } from '../../types/spacing'
import type { ZeroHeightTheme } from '../../types/zero-height-theme'
import type { BothrsWebTheme } from '../types/bothrs-web-theme'

type BothrsThemeProviderProps = {
  children: ReactNode
  theme: ZeroHeightTheme
  config: {
    spacingBase: number
  }
}

const BothrsWebThemeProvider = ({ children, theme, config }: BothrsThemeProviderProps) => {
  const composedTheme: BothrsWebTheme = useMemo(() => {
    const spacingPxList: Partial<SpacingPx> = {}
    const spacingList: Partial<SpacingValue> = {}

    // Dynamically generate the spacing classes
    Array.from({ length: 20 })
      .fill(null)
      .forEach((_, index) => {
        const key = `Space${index + 1}` as SpacingKey
        const value = (index + 1) * config.spacingBase

        spacingList[key] = value
        spacingPxList[key] = `${value}px`
      })

    return mergeDeepRight(theme, {
      UI: {
        BorderRadius: {
          Small: 4,
          Large: 12,
        },
        SpacingPx: spacingPxList as SpacingPx,
        Spacing: spacingList as SpacingValue,
      },

      // TODO
      //   Animations: {
      //     Small: {
      //       Expanding: 150,
      //       Collapsing: 100,
      //     },
      //     Medium: {
      //       Expanding: 200,
      //       Collapsing: 175,
      //     },
      //     Large: {
      //       Expanding: 300,
      //       Collapsing: 275,
      //     },
      //   },
    })
  }, [config.spacingBase, theme])

  return <ThemeProvider theme={composedTheme}>{children}</ThemeProvider>
}

export { BothrsWebThemeProvider }
